import { StatsAggregationPeriodDto } from "services/stats/restModels";

const pad = (value: number): string => String(value).padStart(2, "0");

/*
* Подпись точки графика. Зависит от шага: у часового нужны часы, у месячного — месяц и год.
* Дату к часам добавляем, только когда ряд не помещается в одни сутки, — иначе двадцать четыре
* подписи с одинаковым числом ничего не сообщают, а места занимают.
* */
export const formatPointLabel = (
    from: number,
    period: StatsAggregationPeriodDto,
    spansMultipleDays: boolean
): string => {
    const date = new Date(from);

    const day = `${pad(date.getDate())}.${pad(date.getMonth() + 1)}`;
    const time = `${pad(date.getHours())}:${pad(date.getMinutes())}`;

    if (period === "Minutes" || period === "Hours") {
        return spansMultipleDays ? `${day} ${time}` : time;
    }

    if (period === "Months") return `${pad(date.getMonth() + 1)}.${date.getFullYear()}`;

    return day;
};

const MILLIS_IN_DAY = 24 * 60 * 60 * 1000;

export const spansMultipleDays = (from: number, to: number): boolean =>
    to - from > MILLIS_IN_DAY ||
    new Date(from).getDate() !== new Date(to).getDate();
